export default __webpack_public_path__ + "static/media/cm_1.e0ec696a.png";